import { buildBindable } from '@monofe/di';
import type { IZip } from '../interface/zip';
import { bindZip, injectZip, unbindZip } from '../interface/zip';
import TYPES from '../util/types';
const loader = import('./zip');

async function _build(): Promise<IZip> {
    return (await loader).default;
}

export default buildBindable<IZip>({
    id: TYPES.IZip,
    bind: bindZip,
    remove: unbindZip,
    inject: injectZip,
    build: () => _build(),
});
